<template>
  <button
    type="button"
    class="w-full flex items-center p-4"
    @click="setOpen(true)"
  >
    <span class="sr-only">{{ trans.get('miliboo.common.open') }} {{ item.label }}</span>
    <span class="text-left font-semibold flex-grow text-gray-700">
      {{ item.label }}
    </span>
    <v-icon-chevron-r class="h-6 w-6 text-gray-700" />
  </button>
  <TransitionRoot
    as="template"
    :show="open"
  >
    <Dialog
      as="div"
      class="fixed inset-0 flex z-40 lg:hidden"
      @close="setOpen(false)"
    >
      <TransitionChild
        as="template"
        enter="transition-opacity ease-linear duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-black bg-opacity-0 transition-opacity" />
      </TransitionChild>
      <TransitionChild
        as="template"
        enter="transition ease-in-out duration-300 transform"
        enter-from="-translate-x-full"
        enter-to="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leave-from="translate-x-0"
        leave-to="-translate-x-full"
      >
        <div class="relative bg-white max-w-xs w-full shadow-xl pb-12 flex flex-col overflow-y-auto">
          <TheMainMenuMobilePannelHeader
            :set-open="setOpen"
            @close="$emit('close')"
          />
          <h2 class="text-left font-semibold text-lg text-gray-700 p-4 border-t border-gray-800">
            {{ item.label }}
          </h2>
          <nav :aria-label="item.label">
            <ul class="divide-y divide-gray-800 border-y border-gray-800">
              <li
                v-for="sub in item.child_menu"
                :key="sub.id"
              >
                <TheMainMenuMobilePannelPannel
                  v-if="sub.child_menu.length > 0"
                  :item="sub"
                  :parent="item"
                  :image-proxy-url="imageProxyUrl"
                  @close="setOpen(false) || $emit('close')"
                />
                <a
                  v-else
                  class="text-left flex-grow w-full flex items-center p-4 text-gray-600 text-base"
                  :href="`/${sub.slug}`"
                >
                  <span class="text-left flex-grow">
                    {{ sub.label }}
                  </span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>
<script setup>
import { inject } from 'vue';
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import TheMainMenuMobilePannelPannel from './TheMainMenuMobilePannelPannel.vue';
import useOpen from '../../composables/useOpen';
import TheMainMenuMobilePannelHeader from './TheMainMenuMobilePannelHeader.vue';

defineProps({
  item: {
    type: Object,
    required: true,
  },
  imageProxyUrl: {
    type: String,
    required: true,
  },
});

defineEmits(['close']);

const trans = inject('translate');

const { open, setOpen } = useOpen();

</script>
